import React from 'react';
import classnames from 'classnames';
import { Button } from '@getsynapse/design-system';

interface ToggleButton {
  className?: string;
  children: (isSelected: boolean) => JSX.Element;
  key: string;
  'data-cy'?: string;
}

const ToggleButtonGroup: React.FC<{
  className?: string;
  buttonsList: ToggleButton[];
  onChange: (value: string) => void;
  selected?: string;
}> = ({ className, buttonsList, onChange, selected }) => {
  return (
    <div
      className={classnames(
        'h-8 p-1 flex bg-neutral-lightest shadow-toggle-button-group rounded',
        className
      )}
    >
      {buttonsList.map((button: ToggleButton, index: number) => {
        const isSelected = selected === button.key;
        return (
          <Button
            key={index}
            size='small'
            variant='tertiary'
            onClick={() => onChange(button.key)}
            data-cy={button['data-cy']}
            aria-label={`${button.key}_view`}
            className={classnames(
              'p-1 h-6 w-6 item-center justify-center',
              {
                'bg-primary text-neutral-white hover:bg-primary hover:text-neutral-white':
                  isSelected,
                'bg-lightest text-neutral-dark hover:bg-neutral-lighter':
                  !isSelected,
              },
              button.className
            )}
          >
            {button.children(isSelected)}
          </Button>
        );
      })}
    </div>
  );
};

export default ToggleButtonGroup;
